<template>
	<div class="sp-template">
		<div class="h-title">分公司管理</div>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<el-form :inline="true" :model="theForm" class="demo-form-inline" size="small">
          <el-form-item label="公司名称">
            <el-input v-model.lazy.trim="theForm.name" auto-complete="off" placeholder="公司名称" clearable ></el-input>
          </el-form-item>
          <el-button size="small" type="primary" @click="initQuery">搜索</el-button>
				</el-form>
				<div>
					<el-button size="small" class="btn-cyan" @click="addData">添加</el-button>
				</div>
			</div>
			<el-table ref="multipleTable" :data="datas" stripe tooltip-effect="dark" style="width: 100%">
				<el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="address" label="地址"></el-table-column>
        <el-table-column prop="contact" label="联系人"></el-table-column>
        <el-table-column prop="phone" label="联系电话"></el-table-column>
				
				<el-table-column label="操作">
					<template slot-scope="scope">
            <i  class="el-icon-edit-outline" @click="handleEdit(scope.$index, scope.row)" title="编辑"></i>						
            <i  class="el-icon-delete" @click="deleteData(scope.$index, scope.row)" title="删除"></i>						
            <!-- <el-button size="mini" type="danger" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)" >编辑</el-button> -->
            <!-- <el-button size="mini" type="info" icon="el-icon-delete" @click="deleteData(scope.$index, scope.row)" >删除</el-button> -->
          </template>
          
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination background 
				@size-change="handleSizeChange" 
        @current-change="handleCurrentChange" 
        :current-page="currentPage" 
        :page-sizes="[10, 20, 50, 100]" 
        :page-size="pageSize" 
        layout="total, sizes, prev, pager, next, jumper" 
        :total = "parseInt(total)">
			</el-pagination>

			<!-- 弹窗 -->
			<el-dialog title="添加/修改" :visible.sync="dialogFormVisible" :before-close="emptyForm" @close="resetForm()" width="500px" class="fullwidth-form__dialog">
				<el-form :model="addForm" status-icon :rules="rule" ref="addForm" size="small" :label-width="formLabelWidth">
					
          <el-form-item label="公司名称" prop="name">
						<el-input v-model.lazy.trim="addForm.name" auto-complete="off" placeholder="公司名称"></el-input>
          </el-form-item>
          <el-form-item label="地址"  >
						<el-input v-model.lazy.trim="addForm.address" autocomplete="off" auto-complete="off" placeholder="地址"></el-input>
          </el-form-item>
          <el-form-item label="联系人" >
						<el-input v-model.lazy.trim="addForm.contact" auto-complete="off" placeholder="联系人"></el-input>
          </el-form-item>
          <el-form-item label="电话"  >
						<el-input v-model.lazy.trim="addForm.phone" auto-complete="off" placeholder="电话"></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" @click="resetForm()">取 消</el-button>
					<el-button size="small" type="primary" @click="save()">确 定</el-button>
				</div>
			</el-dialog>

      
		</el-card>
	</div>
</template>

<script>
export default {
  data() {
    return {
      exchangeRateEditLogsVisible: false,
      exchangeRateEditLogs: [],
      theForm: {
        name: ""
      },
      datas: [],
      addForm: {
        id: "",
        name: "",
        address: "",
        contact: "",
        phone: ""
      },
      currentPage: 1, // 当前是第几页
      pageSize: 50, // 每页显示条目个数
      total: 0, // 总条目数
      dialogFormVisible: false,
      formLabelWidth: "80px",
      rule: {
        name: [
          { required: true, message: "请输入公司名称", trigger: "blur" }
        ]
      },
      currencies: []
    };
  },
  components: {},
  created() {
    setTimeout(() => {
      this.query();
    }, 1000);
  },
  computed: {
    //权限
    configs() {
      let conf = JSON.parse(sessionStorage.configs),
        arr = [];
      conf.forEach((d, i) => {
        arr.push(d.name);
      });
      return arr;
    }
  },
  methods: {
    // 时间戳转换成时间
    timestampToTime (data) {
      let date = new Date(data);
      let Y = date.getFullYear() + '-';
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
      let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s
    },
    // 搜索
    initQuery(){
      this.currentPage = 1;
      this.query();
    },
    // 初始化查询方法
    query() {
      let _this = this;
      _this.$request1({
        method: 'get',
        url: '/system/company',
        xhrFields: {
          withCredentials: true
        },
        params: {
          page:  _this.currentPage,
          pageSize: _this.pageSize,
          name: _this.theForm.name
        }
      })
        .then(response => {
          if (response.data.success) {
            if (response.data.data && response.data.data.length > 0) {
              _this.datas = response.data.data;
              _this.total = response.data.total;
            } else {
              _this.datas = [];
            }
          } else {
            _this.$message.error(response.data.message);
          }
        })
        .catch(error => {});
    },

    // 添加/编辑
    save() {
      let _this = this;
      this.$refs['addForm'].validate(valid => {
        if (valid) {
          this.$request1({
            method: 'post',
            url: '/system/company',
            headers: {
              "content-type": "application/json"
            },
            data: JSON.stringify(_this.addForm)
          })
            .then(response => {
              if (response.data.success) {
                this.$message.success("成功！");
                this.initQuery();
                this.emptyForm();
                
              } else {
                this.$message.error(response.data.message);
              }
            })
            .catch(error => {});
        } else {
          return false;
        }
      });
    },
    
    addData() {
      this.addForm  = {
        id: "",
        name: "",
        address: "",
        contact: "",
        phone: "",
        status: 1
      };
      this.dialogFormVisible = true;
    },
    //编辑
    handleEdit(index, row) {
			this.addForm.id = row.id;
      this.addForm.name = row.name; 
      this.addForm.address = row.address;
      this.addForm.phone = row.phone;
      this.addForm.contact = row.contact;

      this.dialogFormVisible = true;
    },
    deleteData(index, row){
      let _this = this;
      let form = {"id": row.id, "status": 0};

      this.$confirm("确定删除【"+ row.name +"】？", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
          _this.$request1({
            method: 'post',
            url: '/system/company/delete',
            headers: {
              "content-type": "application/json"
            },
            data: JSON.stringify(form)
          }).then(response => {
              if (response.data.success) {
                _this.$message.success("success");
                _this.initQuery();
                _this.emptyForm();
              } else {
                _this.$message.error(response.data.message);
              }
            })
            .catch(error => {});
			})
			.catch(() => {
				this.$message({
					type: "info",
					message: "已取消删除"
				});
      });
      
    },
    //清空表单
    emptyForm() {
      this.addForm  = {
        id: "",
        name: "",
        address: "",
        contact: "",
        phone: ""
      };
      this.$refs['addForm'].resetFields();
      this.dialogFormVisible = false;
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.query();
    },
    resetForm() {
      this.$refs['addForm'].clearValidate();
      this.emptyForm();
    }
  }
};
</script>

<style lang="scss" scoped>
.box-card {
  margin: 20px -10px;
}
</style>


// WEBPACK FOOTER //
// src/views/system/company.vue